import styled from "styled-components";
import Navbar from "../components/navbar/Navbar";
import CheckCertificate from "../components/section/certificate/CheckCertificate";
import Footer from "../components/section/footer/Footer";
import MenuSpacer from "../components/spacer/MenuSpacer";

const Wrapper = styled.div``;

function VerifyOwnershipPage() {
  return (
    <Wrapper>
      <Navbar />
      <MenuSpacer extraSpace={true} />
      <CheckCertificate />
      {/* <Certificate /> */}
      <Footer />
    </Wrapper>
  );
}

export default VerifyOwnershipPage;
